module.exports = __webpack_public_path__ + "static/img/home_productcard_pool_mobile.eacc8fb6.jpg";